/**
 * Marketing integrations configuration
 * Centralizes all marketing-related configurations and API keys
 */

export const marketingConfig = {
  segment: {
    writeKey: import.meta.env.VITE_SEGMENT_KEY,
  },
  mixpanel: {
    token: import.meta.env.VITE_MIXPANEL_TOKEN,
  },
  facebook: {
    pixelId: import.meta.env.VITE_FB_PIXEL_ID,
    accessToken: import.meta.env.VITE_FB_ACCESS_TOKEN,
  },
  hubspot: {
    portalId: import.meta.env.VITE_HUBSPOT_PORTAL_ID,
  },
};
